import {apiGet} from "./api"

export const getListOrg = async (data) => {
    return await apiGet('organizations', data);
}